import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import $ from 'jquery'
import { cookie } from './http/utils'
import { urlfix } from './index'
import config from './http/config'
import 'babel-polyfill'

// import './registerServiceWorker'

// import './assets/iconfont/iconfont.css'
import './assets/css/reset.css'
import './assets/css/public.css'

Vue.prototype.$eventBus = Vue.prototype.$eventBus || new Vue()

Vue.filter('urlFix', urlfix)

declare global {
  interface Window { _czc: any, zhuge: any }
}
// 声明_czc对象
window._czc = window._czc || []
// 绑定siteid
window._czc.push(['_setAccount', '1276550549'])

// 声明zhuge对象
window.zhuge = window.zhuge || {}

Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  // 用户已登录，路由重定向到学习首页
  // cookie.delCookie('user_id')
  if (cookie.getCookie('user_id')) {
    window.location.replace(config.rootDomain + '/app/index')
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
